import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import s from './shippingAddress.module.css';
import { formatAddressMultiLine } from '../../lib/addresses';

const mapStateToProps = ({
  language,
  page: { countryCode },
  addresses: { shippingAddress = {} } = {},
}) => ({
  language,
  addressLines: formatAddressMultiLine({
    address: {
      name: shippingAddress.customer_name,
      company: shippingAddress.company,
      address1: shippingAddress.street_1,
      address2: shippingAddress.street_2,
      city: shippingAddress.city,
      region: shippingAddress.state,
      postalCode: shippingAddress.zip,
    },
    countryCode,
  }),
});

const Component = ({ language, addressLines }) => (
  <div className={`${s.shipping_address_container} shipping-address-container`}>
    <h2 className={`${s.shipping_address_title}`} data-test="shipping-address-header">
      {language['returns.step_3.shipping_address']}
    </h2>
    <section className={`${s.shipping_address_item_holder}`}>
      {addressLines.map((addressLine, index) => (
        <span
          key={index} // eslint-disable-line react/no-array-index-key
          className={`${s.shipping_address_item}`}
          data-test={`shipping-address-${index}`}
        >
          {addressLine}
        </span>
      ))}
    </section>
  </div>
);

Component.propTypes = {
  language: PropTypes.object.isRequired,
  addressLines: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export const ShippingAddress = connect(mapStateToProps)(Component);
